import { Routes } from '@angular/router';
import { ErrorComponent } from './error.component';

export const ERROR_ROUTES: Routes = [
    {
        path: 'error',
        component: ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
    },
    {
        path: 'access-denied',
        component: ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title',
            error403: true
        },
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/error/error.route.ts